export const idx_data_thumb_type = [];

idx_data_thumb_type.push({
  type: '',
});

idx_data_thumb_type.push({
  type: 'Round',
});

idx_data_thumb_type.push({
  type: 'Oval',
});
